import React, {PropTypes} from 'react';
import Select from 'react-select';
import classNames from 'classnames';

const Search = ({
  searchByOptions,
  selectedOption,
  searchValue,
  onSearchByOptionClick,
  onSearchEnterKeyPress,
  onSearchClick,
  onSearchValueChange
}) => (
  <div> 
    <p>A minimum of three characters are required.</p>
    <div className={classNames(
        'input-group input-group-lg'
      )}   >
      <div className="input-group-btn">
        <Select  
              options={searchByOptions.map((item) => ({value: item.id, label: item.description}))}
              searchable={false}
              clearable={false}
              className="Big-Select"
              value={selectedOption ? [selectedOption].map((item) => ({value: item.id, label: item.description})).find(() => true) : null}
              onChange={event => {
                if (event)
                  onSearchByOptionClick(event.value);
                else
                  onSearchByOptionClick(null);
          }}
        />
      </div>
      <input type="text" 
        autoFocus
        placeholder="Type your search here..."
        className="form-control"
        value={searchValue}
        onChange={event => onSearchValueChange(event.target.value)}
        onKeyDown={onSearchEnterKeyPress}
      />
      <span className="input-group-btn" >
        <button className="btn btn-primary"
          type="button"
          onClick={onSearchClick}
          disabled={!searchValue || searchValue.trim().length < 3}>
          <i className="fa fa-search" />
        </button>
      </span>
    </div>
  </div>
);

Search.propTypes = {
  searchByOptions: PropTypes.arrayOf(PropTypes.object),
  selectedOption: PropTypes.object,
  searchValue: PropTypes.string,
  onSearchByOptionClick: PropTypes.func,
  onSearchEnterKeyPress: PropTypes.func,
  onSearchClick: PropTypes.func,
  onSearchValueChange: PropTypes.func
};

Search.defaultProps = {
  searchByOptions: [],
  searchValue: ''
};

export default Search;



// WEBPACK FOOTER //
// ./src/features/admin/home/Search.jsx